export const environment = {
  production: true,
  "apiURL": "https://test.api-gateway.mycargoservices.net/api/v3/",
  "printURL": "http://localhost:8791/v1/",
  "fulfillmentURL": "https://test.api-gateway.mycargoservices.net/fulfillment/v1/",
  "storageURL": "https://test.api-gateway.mycargoservices.net/storage/v1/"
};





// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/environments/environment.ts